export const PLATFORM_MAC = 'Mac|iPad|iPhone|iPod';
export const PLATFORM_WIN = 'Win';
export const PLATFORM_ANDROID = 'Android';
export const PLATFORM_LINUX = 'Linux';
export const PLATFORM_IOS = 'iOS|iPhone|iPad|iPod';
export let IS_EDGE = false;
export let IS_IOS = false;
export let IS_SAFARI = false;
export let IS_WIN = false;
export let IS_MAC = false;
export let IS_ANDROID = false;
export let IS_LINUX = false;
export const isMac = () => {
  var _navigator;
  return IS_MAC = typeof navigator !== 'undefined' && new RegExp(PLATFORM_MAC, 'i').test((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.platform);
};
export const isWin = () => {
  var _navigator2;
  return IS_WIN = typeof navigator !== 'undefined' && new RegExp(PLATFORM_WIN, 'i').test((_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : _navigator2.platform);
};
export const isAndroid = () => {
  var _navigator3;
  return IS_ANDROID = typeof navigator !== 'undefined' && new RegExp(PLATFORM_ANDROID, 'i').test((_navigator3 = navigator) === null || _navigator3 === void 0 ? void 0 : _navigator3.userAgent);
};
export const isLinux = () => {
  var _navigator4;
  return IS_LINUX = typeof navigator !== 'undefined' && new RegExp(PLATFORM_LINUX, 'i').test((_navigator4 = navigator) === null || _navigator4 === void 0 ? void 0 : _navigator4.platform);
};
export const isiOS = () => {
  var _navigator5;
  return IS_IOS = typeof navigator !== 'undefined' && new RegExp(PLATFORM_IOS, 'i').test((_navigator5 = navigator) === null || _navigator5 === void 0 ? void 0 : _navigator5.platform);
};
export const isSafari = () => {
  var _navigator6, _navigator7;
  return IS_SAFARI = typeof navigator !== 'undefined' && /safari/i.test((_navigator6 = navigator) === null || _navigator6 === void 0 ? void 0 : _navigator6.userAgent) && !/chrome/i.test((_navigator7 = navigator) === null || _navigator7 === void 0 ? void 0 : _navigator7.userAgent);
};
export const isEdge = () => {
  var _navigator8;
  return IS_EDGE = typeof navigator !== 'undefined' && /edge/i.test((_navigator8 = navigator) === null || _navigator8 === void 0 ? void 0 : _navigator8.userAgent);
};
isEdge();
isiOS();
isSafari();
isWin();
isAndroid();
isMac();
isLinux();
const pageFocusElements = {};
export function setPageFocusElement(selectorOrElement) {
  let key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  return pageFocusElements[key] = selectorOrElement;
}
export function applyPageFocus() {
  let selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
  let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  try {
    let element = /^[.#]/.test(selector) ? selector : pageFocusElements[selector];
    if (typeof element === 'string' && typeof document !== 'undefined') {
      element = document.querySelector(element);
    } else if (!element && typeof document !== 'undefined') {
      element = document.querySelector('.dnb-no-focus');
    }
    if (!(element instanceof HTMLElement)) {
      return;
    }
    const role = element.getAttribute('role');
    const list = ['a', 'button', 'input', 'textarea', 'select', 'label', 'menu'];
    const isInteractive = list.includes(String(element.nodeName).toLowerCase()) || list.includes(String(role).toLowerCase());
    const hasTabIndex = element.hasAttribute('tabindex');
    const hasNoFocus = element.classList.contains('dnb-no-focus');
    if (!isInteractive) {
      if (!hasTabIndex) {
        element.setAttribute('tabindex', '-1');
      }
      if (!hasNoFocus) {
        element.classList.add('dnb-no-focus');
      }
    }
    element.focus();
    const onBlur = () => {
      if (!isInteractive) {
        if (!hasTabIndex) {
          element.removeAttribute('tabindex');
        }
        if (!hasNoFocus) {
          element.classList.remove('dnb-no-focus');
        }
      }
    };
    element.addEventListener('blur', onBlur, {
      once: true
    });
    if (typeof callback === 'function') {
      callback(element);
    }
  } catch (e) {
    warn('Error on applyPageFocus:', e);
  }
}
export function getOffsetTop(elem) {
  let offsetTop = 0;
  if (elem) {
    do {
      if (!isNaN(elem.offsetTop)) {
        offsetTop += elem.offsetTop;
      }
    } while (elem = elem.offsetParent);
  }
  return offsetTop;
}
export function getOffsetLeft(elem) {
  let offsetLeft = 0;
  if (elem) {
    do {
      if (!isNaN(elem.offsetLeft)) {
        offsetLeft += elem.offsetLeft;
      }
    } while (elem = elem.offsetParent);
  }
  return offsetLeft;
}
export function scrollToLocationHashId() {
  let {
    offset = 0,
    delay = null,
    onCompletion = null
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (typeof document !== 'undefined' && typeof window !== 'undefined' && window.location) {
    try {
      let _timeout;
      const id = String(window.location.hash).replace('#', '');
      if (id.length > 0) {
        const handleScroll = () => {
          const runScroll = () => {
            const totalOffset = getOffsetTop(elem);
            if (totalOffset <= 0) {
              return;
            }
            const top = totalOffset - offset;
            try {
              if (typeof IntersectionObserver !== 'undefined') {
                const intersectionObserver = new IntersectionObserver(entries => {
                  const [entry] = entries;
                  if (entry.isIntersecting) {
                    intersectionObserver.unobserve(elem);
                    if (typeof onCompletion === 'function') {
                      onCompletion(elem);
                    }
                  }
                });
                intersectionObserver.observe(elem);
              }
              if (window.scrollTo) {
                window.scrollTo({
                  top,
                  behavior: 'smooth'
                });
              } else {
                window.scrollTop = top;
              }
            } catch (e) {
              warn('Error on scrollToLocationHashId:', e);
            }
          };
          if (delay > 0) {
            clearTimeout(_timeout);
            _timeout = setTimeout(runScroll, delay);
          } else {
            runScroll();
          }
        };
        const elem = document.getElementById(id);
        if (elem instanceof HTMLElement) {
          window.addEventListener('beforeunload', () => clearTimeout(_timeout));
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', handleScroll);
          } else {
            handleScroll();
          }
        }
        return elem;
      }
    } catch (e) {
      warn('Error on scrollToLocationHashId:', e);
    }
  }
}
export function debounce(func) {
  let wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  let {
    immediate = false,
    instance = null
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let timeout;
  let recall;
  const cancel = () => clearTimeout(timeout);
  function executedFunction() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    let inst = this;
    if (typeof recall === 'function') {
      recall();
    }
    const later = () => {
      timeout = null;
      if (!immediate) {
        recall = func.apply(instance || inst, args);
      }
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      recall = func.apply(instance || inst, args);
    }
    return recall;
  }
  executedFunction.cancel = cancel;
  return executedFunction;
}
export function insertElementBeforeSelection(elem) {
  try {
    const selection = window.getSelection();
    const range = selection.getRangeAt(0);
    range.cloneRange().insertNode(elem);
    selection.addRange(range);
  } catch (e) {}
}
export function getSelectedText() {
  try {
    return window.getSelection().toString();
  } catch (e) {}
  return '';
}
export function hasSelectedText() {
  return getSelectedText().length > 0;
}
export function getSelectedElement() {
  try {
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      let elem = selection.getRangeAt(0).startContainer;
      if (elem && typeof elem === 'object') {
        elem = elem.parentNode;
      }
      return elem;
    }
  } catch (e) {}
  return null;
}
export async function copyToClipboard(string) {
  var _navigator9;
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }
  const selection = window.getSelection();
  const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : false;
  const resetSelection = () => {
    try {
      selection.removeAllRanges();
      selection.addRange(range);
    } catch (e) {}
  };
  const copyFallback = () => {
    try {
      const elem = document.createElement('textarea');
      elem.value = String(string);
      elem.contentEditable = true;
      elem.readOnly = false;
      elem.style.position = 'fixed';
      elem.style.top = '-1000px';
      document.body.appendChild(elem);
      const success = document.execCommand('copy');
      document.body.removeChild(elem);
      resetSelection();
      if (success) {
        return true;
      }
    } catch (e) {
      return e;
    }
    return `Could not copy! Unknown reason. ${string}`;
  };
  let success;
  if (typeof navigator !== 'undefined' && (_navigator9 = navigator) !== null && _navigator9 !== void 0 && _navigator9.clipboard) {
    try {
      await navigator.clipboard.writeText(String(string));
      success = true;
      resetSelection();
    } catch (e) {
      success = e;
      const newTry = copyFallback();
      if (newTry === true) {
        success = newTry;
      }
    }
  } else {
    success = copyFallback();
  }
  return success;
}
export const warn = function () {
  if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production' && typeof console !== 'undefined' && typeof console.log === 'function') {
    const isBrowser = typeof window !== 'undefined' && process.env.NODE_ENV !== 'test';
    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      params[_key2] = arguments[_key2];
    }
    if (isBrowser) {
      const styles = [`padding: 0.125rem 0.5rem ${IS_SAFARI ? '' : '0'}`, 'font-weight: bold', 'color: #00343E', 'background: #A5E1D2'].join(';');
      console.log('%cEufemia', styles, ...params);
    } else {
      console.log('\u001b[0m\u001b[1m\u001b[38;5;23m\u001b[48;5;152mEufemia\u001b[49m\u001b[39m\u001b[22m\u001b[0m', ...params);
    }
  }
};
//# sourceMappingURL=helpers.js.map